import { useEffect } from 'react';

import styles from '../../pages/PublicPage.module.css';
import { useStoreState, useStoreActions } from '../../reducers';
import HtmlEula from '../users/HtmlEula';

type EulaViewerProps = {
  setIsEulaVisible: (value: boolean) => void;
  setIsEulaAccepted: (value: boolean) => void;
};

export default function EulaViewer({
  setIsEulaVisible,
  setIsEulaAccepted,
}: EulaViewerProps) {
  const { eulaLink, eulaPdfLink } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const { fetchEulaLink } = useStoreActions((actions) => actions.user);

  const handleRejectEula = () => {
    setIsEulaVisible(false);
  };

  const handleAcceptEula = () => {
    localStorage.setItem('eulaAccepted', 'true');
    setIsEulaVisible(false);
    setIsEulaAccepted(true);
  };

  useEffect(() => {
    fetchEulaLink();
  }, [fetchEulaLink]);

  return (
    <div className={`${styles['auth-content']} ${styles['eula-content']}`} data-testid="eula-viewer-section"> 
      {/* text copy on left */}
      <div className={styles['auth-eula-copy-container']} data-testid="eula-viewer-copy-container">
        <h2 className={styles['auth-page-title']}>Review EULA</h2>
        <p
          className={styles['auth-page-copy']}
          style={{ textTransform: 'none' }}
        >
          Before signing up, please review and accept our End User License
          Agreement (EULA). You need to agree to the terms to create an account.
          Take a moment to read it thoroughly before deciding.
        </p>
      </div>

      {/* eula on right */}
      {/* <PdfEula
        eulaLink={eulaLink}
        handleClose={handleRejectEula}
        handleAcceptEula={handleAcceptEula}
        showAction
      /> */}
      <HtmlEula
        eulaLink={eulaLink}
        eulaPdfLink={eulaPdfLink}
        handleClose={handleRejectEula}
        handleAcceptEula={handleAcceptEula}
        showAction
        data-testid="eula-viewer-html-eula"
      />
    </div>
  );
}
